import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CustomButton from "../../ui/button/Button";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useState } from "react";
import "dayjs/locale/es-mx";

const FechaAsignacionModal = ({ open, onClose, onConfirm }) => {
  const [value, setValue] = useState(dayjs());

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Establecer fecha de asignación</DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es-mx">
          <DateTimePicker
            label="Fecha de asignación"
            value={value}
            onChange={(newValue) => setValue(newValue)}
            sx={{ margin: "10px 0 0" }}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={onClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Guardar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={() => onConfirm(value.toISOString())}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default FechaAsignacionModal;
